import { streamsenseSnippet } from './streamsense_snippet';

/**
 * Streamsense is a part of Comscore tracking
 * specifically for video plays.
 */
export default function loadStreamsense(window) {
  streamsenseSnippet(window);
}
